import React from 'react'
import {
  Modal,
  TimePicker,
  Input,
  Col,
  Row,
  message,
  Radio,
  Button,
  Switch,
} from 'antd'
import moment from 'moment'
import EditForm from './editForm'
import SwitchForm from './switchForm'
import { ACTIONTYPE } from '../constants'

class DetailModal extends React.Component {
  state = {
    loading: false,
    isTakesOneTime: false,
    couponItem: {
      club: {
        id: '',
        name: '',
      },
      coupon: {
        id: -1,
        typeId: 2, // 卡券类型： 1：金额；2：时长
        denomination: '', // 面额 钟时券为分钟 金额券为元
        issue: '', // 发行数量
        name: '', // 卡券名称
        amount: '', // 金额(界面显示是元单位；上传给后台是分单位 x100)
        limitDuration: '', // 限制使用时长(每日显示使用多少分钟)
        canMultiTimeUse: true, // 有效期内可多次使用
        canSharable: false, // 可转赠他人
        isTableLimit: true, //  接口数据解析：限定桌台使用;   false: 代表全场球台通用；true: 代表限定桌台使用 (上传时需要取反 获取接口数据时也要取反)
        isLimitTime: false, // 每日限时使用
        canWholeDay: true, // 营业时间内均可使用(可全天使用)
        limitGetType: 0, //限领类型：0.无；1.每日；2.每周；3.每月；4.终身；不设置默认传0
        isPrivacySharable: false, // (定向发放)是私密分享
        isPublicDisplay: true, // 是否公开展示
      },
      expiration: {
        startDate: '', // 有效期开始日期
        endDate: '', // 有效期结束日期
      },
      duration: {
        // isForceFinishOnEndTime: false, // 到结束时间是否关灯
        startTime: '', // 营业时间开始时间(卡券可使用开始时间); 上次给后台时需要 位数增加秒  00:00:00
        endTime: '', // 营业时间结束时间(卡券可使用结束时间)
      },
      tableIds: [], // 已选择的球台
      couponStock: {
        remain: 0, // 卡券发行余量
        overdue: 0, // 卡券状态：0.正常；1.过期；2.售空
      },
    },
  }

  componentDidMount() {
    console.log('传输数据：', this.props)
    const { couponItem } = this.props
    if (couponItem) {
      const couponItemData = JSON.parse(JSON.stringify(couponItem))
      this.setState({
        couponItem: couponItemData,
        isTakesOneTime: couponItem.coupon.limitGetType > 0,
      })
    } else {
      const clubId = sessionStorage.getItem('club_id')
      const clubName = sessionStorage.getItem('club_name')
      this.setState({
        couponItem: {
          ...this.state.couponItem,
          club: {
            id: clubId,
            name: clubName,
          },
        },
      })
    }
  }

  changTable = (table_id) => {
    const tableId = +table_id
    const { couponItem } = this.state
    const new_select = [...couponItem.tableIds]
    if (new_select.indexOf(tableId) == -1) {
      new_select.push(tableId)
    } else {
      new_select.splice(new_select.indexOf(tableId), 1)
    }
    const changeItem = { ...couponItem }
    changeItem.tableIds = new_select
    this.setState({ couponItem: changeItem })
  }

  onOk = () => {
    console.log('确认:', this.state.couponItem)
    this.props.onOk(this.state.couponItem)
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { confirmLoading, actionType, clubTables } = this.props
    const { isTakesOneTime, couponItem } = this.state

    const format = 'HH:mm'
    const disabled = actionType == ACTIONTYPE.DETAIL // 详情

    const limitedTime = (
      <Input
        style={{ marginTop: '5px' }}
        suffix={'分钟'}
        value={couponItem.coupon.limitDuration}
        disabled={disabled}
        type={'number'}
        onChange={(e) => {
          couponItem.coupon.limitDuration = e.target.value
          this.setState({ couponItem: couponItem })
        }}
      />
    )

    const singleTimesRadio = (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '60%' }}>领取时限：（单选）</div>
        <div>
          <Radio.Group
            value={couponItem.coupon.limitGetType}
            disabled={disabled}
            onChange={(e) => {
              couponItem.coupon.limitGetType = e.target.value
              this.setState({ couponItem: couponItem })
            }}
          >
            <Radio value={1}>每日限领一次</Radio>
            <Radio value={2}>每周限领一次</Radio>
            <Radio value={3}>每月限领一次</Radio>
            <Radio value={4}>终身限领一次</Radio>
          </Radio.Group>
        </div>
      </div>
    )

    // const noticeRadio = (
    //   <div style={{ marginLeft: '30px' }}>
    //     {/* <Checkbox.Group options={options} /> */}
    //     <Checkbox
    //       checked={needFlashingReminder}
    //       onChange={(e) => {
    //         this.setState({ needFlashingReminder: e.target.checked })
    //       }}
    //     >
    //       闪灯提醒(结束前5分钟闪灯一次)
    //     </Checkbox>

    //     <Checkbox
    //       checked={needWechatReminder}
    //       onChange={(e) => {
    //         this.setState({ needWechatReminder: e.target.checked })
    //       }}
    //     >
    //       发送微信信息
    //     </Checkbox>
    //   </div>
    // )

    const businessHours = (
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '5px',
        }}
      >
        <TimePicker
          disabled={disabled}
          clearIcon={false}
          onChange={(time, timeString) => {
            couponItem.duration.startTime = timeString + ':00'
            this.setState({ couponItem: couponItem })
          }}
          value={
            couponItem.duration
              ? moment(
                  couponItem.duration.startTime != ''
                    ? couponItem.duration.startTime
                    : '00:00',
                  'HH:mm:ss'
                )
              : ''
          }
          format={format}
          placeholder={'开始时间'}
          defaultValue={moment('00:00', format)}
        />
        <TimePicker
          disabled={disabled}
          clearIcon={false}
          onChange={(time, timeString) => {
            couponItem.duration.endTime = timeString + ':00'
            this.setState({ couponItem: couponItem })
          }}
          value={
            couponItem.duration
              ? moment(
                  couponItem.duration.endTime != ''
                    ? couponItem.duration.endTime
                    : '00:00',
                  'HH:mm:ss'
                )
              : ''
          }
          format={format}
          placeholder={'结束时间'}
          defaultValue={moment('00:00', format)}
        />

        {/* <div>
          <span className={'zrs-label'}>到结束时间是否关灯: </span>
          <Switch
            style={{ float: 'right' }}
            checked={
              couponItem.duration
                ? couponItem.duration.isForceFinishOnEndTime
                : false
            }
            onChange={(value) => {
              const item = couponItem
              item.duration.isForceFinishOnEndTime = value
              this.setState({
                couponItem: item,
              })
            }}
          />
        </div> */}
      </div>
    )

    const ballAll = (
      <Row gutter={24} style={{ marginTop: '5px' }}>
        {clubTables &&
          clubTables.length > 0 &&
          clubTables.map((v, idx) => {
            const flag = couponItem.tableIds.indexOf(+v.table_id) != -1
            return (
              <Col span={8} key={idx}>
                <Button
                  className={`zrs-ball-item ${flag ? 'zrs-ball-item-on' : ''}`}
                  style={{ borderTop: idx > 3 ? '0' : '' }}
                  disabled={disabled}
                  onClick={() => !disabled && this.changTable(v.table_id)}
                >
                  {v.name}
                </Button>
              </Col>
            )
          })}
      </Row>
    )
    const columns = [
      { editType: 'text', label: '俱乐部', text: couponItem.club.name },
      {
        editType: disabled ? 'text' : 'input',
        value: couponItem.coupon.name,
        label: '卡券名称',
        style: { width: '200px' },
        onChange: (e) => {
          couponItem.coupon.name = e.target.value
          this.setState({ couponItem: couponItem })
        },
      },
      {
        editType: disabled ? 'text' : 'select',
        label: '卡券类型',
        options: [
          { value: 1, text: '金额券' },
          { value: 2, text: '钟时券' },
        ],
        style: { width: '100px' },
        value: couponItem.coupon.typeId,
        text: couponItem.coupon.typeId == 1 ? '金额券' : '钟时券',
        onChange: (value) => {
          couponItem.coupon.typeId = +value
          this.setState({ couponItem: couponItem })
        },
      },
      {
        editType: disabled ? 'text' : 'input',
        label: '卡券面额',
        suffix: couponItem.coupon.typeId == 1 ? '元' : '分钟',
        style: { width: '100px' },
        type: 'number',
        value: couponItem.coupon.denomination,
        onChange: (e) => {
          couponItem.coupon.denomination = e.target.value
          this.setState({ couponItem: couponItem })
        },
      },
      {
        editType: disabled ? 'text' : 'input',
        type: 'number',
        label: '发行数量',
        disabled: disabled,
        value: disabled
          ? couponItem.coupon.issue == 0
            ? '不限量'
            : couponItem.coupon.issue
          : couponItem.coupon.issue,
        suffix: '张',
        style: { width: '100px' },
        tipContent: '输入“0”即为不限量',
        onChange: (e) => {
          couponItem.coupon.issue = e.target.value
          this.setState({ couponItem: couponItem })
        },
      },
      {
        editType: 'text',
        label: '剩余数量',
        type: 'number',
        value:
          couponItem.coupon.issue > 0
            ? couponItem.coupon.issue + '张'
            : '不限量',
        style: { width: '100px' },
      },
      {
        editType: disabled ? 'text' : 'date',
        value:
          !disabled && actionType != ACTIONTYPE.ADD
            ? [
                moment(couponItem.expiration.startDate),
                moment(couponItem.expiration.endDate),
              ]
            : couponItem.expiration.startDate && couponItem.expiration.endDate
            ? [
                moment(couponItem.expiration.startDate),
                moment(couponItem.expiration.endDate),
              ]
            : '',
        text: `${couponItem.expiration.startDate} - ${couponItem.expiration.endDate}`,
        label: '有效期',

        onChange: (date, dateString) => {
          couponItem.expiration.startDate = dateString[0]
          couponItem.expiration.endDate = dateString[1]
          this.setState({ couponItem: couponItem })
        },
      },
      {
        editType: disabled ? 'text' : 'input',
        label: '售价',
        suffix: '元',
        type: 'number',
        value: disabled
          ? `${couponItem.coupon.amount}元`
          : couponItem.coupon.amount,
        style: { width: '100px' },
        tipContent: '输入“0”或不填写即为可免费领取',
        onChange: (e) => {
          couponItem.coupon.amount = e.target.value
          this.setState({ couponItem: couponItem })
        },
      },
    ].filter((v) => {
      if (!disabled) {
        if (v.label != '剩余数量') {
          return v
        }
      } else {
        return v
      }
    })

    const switchColumns = [
      {
        label: '营业时间内均可使用',
        checked: couponItem.coupon.canWholeDay,
        content: businessHours,
        disabled: disabled,
        handleChange: (checked) => {
          couponItem.coupon.canWholeDay = checked
          this.setState({ couponItem: couponItem })
        },
      },
      {
        label: '有效期内可多次使用',
        checked: couponItem.coupon.canMultiTimeUse,
        disabled: disabled,
        handleChange: (checked) => {
          couponItem.coupon.canMultiTimeUse = checked
          this.setState({ couponItem: couponItem })
        },
      },
      {
        label: '可转赠他人',
        checked: couponItem.coupon.canSharable,
        disabled: disabled,
        handleChange: (checked) => {
          couponItem.coupon.canSharable = checked
          this.setState({ couponItem: couponItem })
        },
      },
      {
        label: '是否公开展示',
        checked: couponItem.coupon.isPublicDisplay,
        disabled: disabled,
        handleChange: (checked) => {
          couponItem.coupon.isPublicDisplay = checked
          this.setState({ couponItem: couponItem })
        },
      },
      // {
      //   label: '定向发放（不可二次转发）',
      //   checked: couponItem.coupon.isPrivacySharable,
      //   disabled: disabled,
      //   handleChange: (checked) => {
      //     couponItem.coupon.isPrivacySharable = checked
      //     this.setState({ couponItem: couponItem })
      //   },
      // },
      {
        label: '全场球台通用',
        checked: couponItem.coupon.isTableLimit,
        disabled: disabled,
        content: ballAll,
        handleChange: (checked) => {
          couponItem.coupon.isTableLimit = checked
          this.setState({ couponItem: couponItem })
        },
      },
      {
        label: '每个账号限领一次',
        disabled: disabled,
        checked: isTakesOneTime,
        content: singleTimesRadio,
        handleChange: (checked) => {
          couponItem.coupon.limitGetType = checked ? 4 : 0
          this.setState({
            isTakesOneTime: checked,
            couponItem: couponItem,
          })
        },
      },
      {
        label: '每日使用限时',
        checked: couponItem.coupon.isLimitTime,
        disabled: disabled,
        content: limitedTime,
        handleChange: (checked) => {
          couponItem.coupon.isLimitTime = checked
          this.setState({ couponItem: couponItem })
        },
      },
    ]
    return (
      <Modal
        visible
        width={'600px'}
        destroyOnClose={true}
        cancelText={'取消'}
        okText={'确认'}
        onOk={this.onOk}
        onCancel={this.onCancel}
        confirmLoading={confirmLoading}
      >
        <div>
          <EditForm columns={columns} />
          <SwitchForm columns={switchColumns} />
        </div>
      </Modal>
    )
  }
}

export default DetailModal



// WEBPACK FOOTER //
// ./src/containers/CardManage/components/detailModal.js